//import libs
import React, { Component } from "react";
import NotificationsSystem from "reapop";
import theme from "reapop-theme-bootstrap";
import LoadingBar from "react-redux-loading-bar";
import { connect } from "react-redux";
import { getUser } from "../../store/auth/services";

import Aux from "../Aux";
import Loading from "../../components/Loading";
import Sidebar from "../../../components/Sidebar";

class Auth extends Component {
  static displayName = "Logged In Container";

  componentDidMount() {
    const { isAuthenticated } = this.props;

    if (isAuthenticated) {
      this.props.dispatch(getUser());
    }
  }

  render() {
    let { currentUser } = this.props;
    if (currentUser) {
      return (
        <Aux>
          <LoadingBar className="loading-bar" showFastActions />
          <NotificationsSystem theme={theme} />
          <div className="main-wrapper">
            <Sidebar user={this.props.currentUser} />
            <div className="content-wrapper">{this.props.children}</div>
          </div>
        </Aux>
      );
    } else {
      return <Loading />;
    }
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    currentUser: state.auth.currentUser,
    loading: state.auth.isLoading
  };
};

export default connect(mapStateToProps)(Auth);



// WEBPACK FOOTER //
// ./src/system/containers/Auth/index.jsx